import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lp2-contact-us',
  template: `
    <lp2-header></lp2-header>
    <lp2-title-bar pageTitle="{{ 'pageLinks.talkNow' | translate }}"></lp2-title-bar>
    <lp2-contact-us-picture></lp2-contact-us-picture>
    <lp2-contact-us-links></lp2-contact-us-links>
    <lp2-contact-us-faqs></lp2-contact-us-faqs>
    <lp2-footer></lp2-footer>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./ts/app/contact-us/contact-us.component.ts